import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Head as HeadShell } from '@aviv-unified-frontend/runtime/head';
export const Head = ({ page }) => {
    const pageCapitalized = page.charAt(0).toUpperCase() + page.slice(1);
    const headInfosData = require(`../../../public/data/headInfos/headInfos${page === '' ? 'Base' : pageCapitalized}.json`);
    if (!headInfosData)
        return null;
    const ldJson = headInfosData.structuredData
        ? headInfosData.structuredData.reduce((acc, item) => ({
            ...acc,
            [item.type]: item.content,
        }), {})
        : {};
    return (_jsxs(HeadShell, { children: [_jsx("title", { children: headInfosData.title }), _jsx("meta", { name: "title", content: headInfosData.title }), _jsx("meta", { name: "description", content: headInfosData.description }), headInfosData.openGraphs &&
                headInfosData.openGraphs.map((og) => (_jsx("meta", { property: `og:${og.property}`, content: og.content }, `meta-og-${og.property}`))), headInfosData.socials &&
                headInfosData.socials.map((s) => (_jsx("meta", { name: s.name, content: s.content }, `meta-socials-${s.name}`))), headInfosData.icons &&
                headInfosData.icons.map((i) => (_jsx("link", { rel: i.relation, sizes: i.sizes, href: i.link, type: i.type }, `meta-icons-${i.relation}-${i.sizes}`))), Object.keys(ldJson).length > 0 && (_jsx("script", { type: "application/ld+json", children: JSON.stringify(ldJson) })), _jsx("link", { rel: "canonical", href: headInfosData.canonicalUrl })] }));
};
